module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_2.2282b9a7.jpg";